<ng-container *ngIf="localeDirection$ | async as localeDirection">
  <div
    override
    class="main-container"
    [ngClass]="[localeDirection]"
    dir="{{ localeDirection }}">
    <div class="content-container">
      <ng-content select="[bypass-block]"></ng-content>
      <rd-core-impersonation-banner></rd-core-impersonation-banner>
      <ng-content select="[main-header]"></ng-content>
      <div
        class="router-outlet-container bypass-block-target"
        tabindex="-1"
        role="main"
        aria-label="content">
        <rd-maintenance-page
          *ngIf="isRdPlatformMaintenanceEnabled; else pageContent">
        </rd-maintenance-page>

        <ng-template #pageContent>
          <router-outlet></router-outlet>
        </ng-template>
      </div>

      <ng-content select="[main-footer]"></ng-content>
    </div>
  </div>

  <div
    class="rd-dialog-container"
    [ngClass]="[localeDirection]"
    dir="{{ localeDirection }}"></div>
</ng-container>
